
import { store } from "../Store/store";
import { limpiarToken } from "../Store/slicers/tokenAuth";
import apiCumbres from "./axios";

export const setupInterceptors = () => {
  apiCumbres.interceptors.request.use(
    (config) => {
      const token = store.getState().tknAuth.token;

      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }

      return config;
    },
    (error) => Promise.reject(error)
  );

  apiCumbres.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        store.dispatch(limpiarToken());
      }
      return Promise.reject(error);
    }
  );
};